export default {
    methods:{
        addEventListeners(){
            this.$on("pyInputBlur", function(field){
                this.$parent.$emit('pyInputBlur', field)
            })
            this.$on("pyInputFocus", function(field){
                this.$parent.$emit('pyInputFocus', field)
            })
            this.$on("pyInputChange", function(field){
                this.$parent.$emit('pyInputChange', field)
            })
        }
    }
}